import { useContext } from "react";
import TimezoneContext from "../contexts/TimezoneProvider";

const useTimezone = () => {
  return useContext(TimezoneContext);
};

export default useTimezone;
